(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('skipper-level-holder', {
            parent: 'entity',
            url: '/skipper-level-holder',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.skipperLevelHolder.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holders.html',
                    controller: 'SkipperLevelHolderController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipperLevelHolder');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('skipper-level-holder-detail', {
            parent: 'skipper-level-holder',
            url: '/skipper-level-holder/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'askApp.skipperLevelHolder.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-detail.html',
                    controller: 'SkipperLevelHolderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skipperLevelHolder');
                    $translatePartialLoader.addPart('enumSkipperLevel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SkipperLevelHolder', function($stateParams, SkipperLevelHolder) {
                    return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'skipper-level-holder',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('skipper-level-holder-detail.edit', {
            parent: 'skipper-level-holder-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skipper-level-holder.new', {
            parent: 'skipper-level-holder',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                skipperLevel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('skipper-level-holder');
                });
            }]
        })
        .state('skipper-level-holder.edit', {
            parent: 'skipper-level-holder',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-dialog.html',
                    controller: 'SkipperLevelHolderDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skipper-level-holder.delete', {
            parent: 'skipper-level-holder',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skipper-level-holder/skipper-level-holder-delete-dialog.html',
                    controller: 'SkipperLevelHolderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SkipperLevelHolder', function(SkipperLevelHolder) {
                            return SkipperLevelHolder.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skipper-level-holder', null, { reload: 'skipper-level-holder' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
